import { jsx } from 'react/jsx-runtime';
import { LoadingWorkspaceSidebarLayout } from '@sketch/components';

const WorkspaceSidebarLoadingPage = () => (jsx(LoadingWorkspaceSidebarLayout, {}));

export { WorkspaceSidebarLoadingPage };
